// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"Breadcrumbs_breadcrumbs_h59IV6Y61ClYHJ1TJNmD"};